import React, { useEffect, useState } from 'react'
import { Button, Table } from 'react-bootstrap'
import AddTaskExlusionModal from './AddTaskExlusionModal'
import { useAuth } from '../../../firebase/AuthProvider'
import { DeleteTaskExtentionExclusionAsync, GetTaskExtentionExclusionAsync } from '../../../services/TaskExterntionService/TaskExterntionService'
import { TaskExtensionExclusionDto } from '../../../interfaces/TaskExtentionDtos/taskExtention.model'
import { toast } from 'react-toastify'
import { TaskType } from '../../../Data/SD'
import { PaginationDto } from '../../../interfaces/Employee/Employee'
import Pagination from '../../ui/Pagination/Pagination';
import trashicons from '../../../assets/images/trashicons.svg';
import { showConfirmationDialog } from '../../modal/ConfimationModal/Confimation'
import Loader from '../loader/Loader'

const TaskExclusion = () => {
    const { currentUser } = useAuth();
    const [addTaskExclusionModal, setAddTaskExclusionModal] = useState<boolean>(false);

    const [refreshLish, setRefreshList] = useState<boolean>(true);

    const [taskExtentionExclusion, setTaskExtentionExclusion] = useState<TaskExtensionExclusionDto[]>([]);
    const [extentionCount, setExtentionCount] = useState<number>();

    // pagination state
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });

    // loading state for table-row based loader
    const [loading, setLoading] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);

    const openAddExclusionModal = () => setAddTaskExclusionModal(true);
    const closeAddExclusionModal = () => setAddTaskExclusionModal(false);

    useEffect(() => {
        GetTaskExtentionExclusion()
        // re-run when pagination changes
    }, [pagination, refreshLish]);

    const GetTaskExtentionExclusion = async () => {
        setLoading(true);
        const token = await currentUser?.getIdToken();
        if (!token) return;
        try {
            const res = await GetTaskExtentionExclusionAsync(token, pagination.pageNumber, pagination.pageSize);
            if (res.success) {
                setTaskExtentionExclusion(res.data.items);
                setExtentionCount(res.data.totalCount);
            } else {
                toast.error(res.message);
            }
        } catch (err: any) {
            toast.error(err.message || "Error to get the Extentions")
        } finally {
            setLoading(false);
        }
    }

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }

    const handleDeleteExclusion = async (exclusionId : string) =>{
        // getting the confirmation from user
        const isConfirmed = await showConfirmationDialog();
        if(!isConfirmed) return;

        const token  = await currentUser?.getIdToken();
        if(!token) return;

        setLoader(true);
        DeleteTaskExtentionExclusionAsync(token, exclusionId).then((res)=>{
            if(res.success){
                setRefreshList(!refreshLish);
                toast.success(res.message);
            }else{
                toast.error(res.message);
            }
        }).catch((err)=>{
            toast.error(err.message || "Error to Delete the Exclusion");
        }).finally(()=> setLoader(false))
    }

    return (
        <div className="common_card">
            {loader && <Loader />}
            <div className="top top_bar_flx">
                <div className="top_bar_tittle">
                    <h2>Task exclusion</h2>
                </div>
                <div className="top_right_flx">
                    <Button
                        variant="primary"
                        className="btn_sm"
                        onClick={openAddExclusionModal}
                    >
                        New Task exclusion
                    </Button>
                </div>
            </div>

            <Table responsive className="common_table">
                <thead className="bg-light">
                    <tr>
                        <th>Task</th>
                        <th>Task Type</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>

                    {loading ? (
                        <tr className="text-center">
                            <td colSpan={3}>
                                <p className="mt-5">Loading...</p>
                            </td>
                        </tr>
                    ) : taskExtentionExclusion.length === 0 ? (
                        <tr className="text-center">
                            <td colSpan={3}>
                                <p className="mt-5">No Data Found</p>
                            </td>
                        </tr>
                    ) : (
                        taskExtentionExclusion.map((item, index) => (
                            <tr key={index}>
                                <td>{item.templateInterimTaskTypeId ? TaskType.Interim : TaskType.Recurring}</td>
                                <td>{item.taskTitle}</td>
                                <td>{item.isActive ? "Active" : "Not-Active"}</td>
                                <td>
                                    <span>
                                        <img src={trashicons} alt="trashicons" onClick={() => {
                                            handleDeleteExclusion(item.taskExtensionExclusionId);
                                        }} />
                                    </span>
                                </td>
                            </tr>
                        ))
                    )}

                </tbody>
            </Table>

            {
                (extentionCount && extentionCount > 0) && (
                    <div className="m-t-16">
                        <Pagination
                            currentPage={pagination.pageNumber}
                            totalPages={Math.ceil((extentionCount || 0) / pagination.pageSize)}
                            onPageChange={onPageChange}
                            pageSize={pagination.pageSize}
                            resetPageSize={resetPageSize}
                        />
                    </div>
                )
            }

            {
                addTaskExclusionModal &&
                <AddTaskExlusionModal
                    showAddExclusionModal={addTaskExclusionModal}
                    handleCloseAddExclusionModal={closeAddExclusionModal}
                    refreshList={() => setRefreshList(!refreshLish)}
                />
            }

        </div>
    )
}

export default TaskExclusion